/**
 * Downloads the whole video up front so it plays without buffering when its
 * slide comes up. Returns a blob URL the caller owns and should revoke when
 * done. Requires CORS on the video's host, unlike a plain <video src>, so
 * callers should fall back to the original URL on failure.
 */
export const preloadVideo = async (url: string, signal?: AbortSignal): Promise<string> => {
  const response = await fetch(url, { signal });
  if (!response.ok) throw new Error(`Failed to preload video: ${response.status}`);
  return URL.createObjectURL(await response.blob());
};
